import { List, Map } from "immutable";

import { ContentType } from "@seneca/course-service-types";

import { Action } from "common/types/redux";

import {
  CourseSectionsSpec,
  SpecType
} from "seneca-common/features/assignments/state";
import { getSectionContentIds } from "seneca-common/features/assignments/state/selectors/state/assignments/assignment/spec/courseSectionsSpec";
import { Contents } from "seneca-common/features/course/state";
import actionTypes from "seneca-common/features/course/state/action-types";
import {
  flattenContents,
  flattenSectionsContents
} from "seneca-common/features/course/state/reducers/state/contents";

import StudentAssignment from "../../../models/StudentAssignment";

export default function assignmentContentsReducer(
  state: Map<string, StudentAssignment> = Map<string, StudentAssignment>(),
  action: Action<any>
) {
  switch (action.type) {
    case actionTypes.ADD_COURSE: {
      const course = action.payload.course;
      const contents = flattenContents(course);

      return updateContentTypesBySectionIdForAssignments(state, contents);
    }

    case actionTypes.ADD_COURSE_SKELETON: {
      const contents = flattenSectionsContents(action.payload.sections);
      return updateContentTypesBySectionIdForAssignments(state, contents);
    }

    case actionTypes.ADD_SECTION: {
      const contents = flattenContents(action.payload.section);

      return updateContentTypesBySectionIdForAssignments(state, contents);
    }
    default:
      return state;
  }
}

function updateContentTypesBySectionId(
  spec: SpecType,
  contentTypesBySectionId: Map<string, List<ContentType>> | undefined = Map(),
  contents: Contents
) {
  const sectionContentIds = getSectionContentIds(spec as CourseSectionsSpec);

  if (
    !contents ||
    contents.size === 0 ||
    !sectionContentIds ||
    sectionContentIds.size === 0
  ) {
    return contentTypesBySectionId;
  }

  sectionContentIds.forEach((contentIds, sectionId) => {
    contentIds.forEach(contentId => {
      if (contents.has(contentId)) {
        const contentType =
          contents.get(contentId)?.contentType || ContentType.standard;
        if (contentTypesBySectionId.get(sectionId)?.includes(contentType)) {
          return;
        }
        contentTypesBySectionId = contentTypesBySectionId.update(
          sectionId,
          (contentTypes: List<ContentType> | undefined) =>
            contentTypes ? contentTypes.push(contentType) : List([contentType])
        );
      }
    });
  });

  return contentTypesBySectionId;
}

function updateContentTypesBySectionIdForAssignments(
  assignments: Map<string, StudentAssignment>,
  contents: Contents
) {
  return assignments.map((assignment: StudentAssignment) => {
    const spec = assignment.get("spec");

    return assignment.update(
      "contentTypesBySectionId",
      contentTypesBySectionId =>
        updateContentTypesBySectionId(spec!, contentTypesBySectionId, contents)
    );
  });
}
